module.exports = __webpack_public_path__ + "static/media/rss.412117c7.svg";